export const container = "cja8et0";
export const parent = "p1ufzn4e";
export const column = "ctvjxz2";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");